import { useMutation } from "@tanstack/react-query";
import axios, { AxiosError } from "axios";
import axiosInstance, { getAPIURL } from "../axiosInstance";

export interface PreviewEventStripeDiscountRequest {
  userId: string;
  eventId: number;
  discountCode: string;
  isEventEarlyBird: boolean;
}

export interface PreviewEventStripeDiscountResponse {
  valid: boolean;
  error?: string;
  subtotalAfterEarlyBird?: number;
  couponDiscountAmount?: number;
  subtotalAfterCoupon?: number;
  finalTotal?: number;
  currency?: string;
  memberEventDiscountEligible?: boolean;
}

const GENERIC_EVENT_PROMO_ERROR =
  "This promotion code is invalid or not applicable to this event. Please check the code and try again.";

const sanitizePreviewResponse = (
  response: PreviewEventStripeDiscountResponse,
): PreviewEventStripeDiscountResponse => {
  if (!response.valid && response.error) {
    return {
      ...response,
      error: GENERIC_EVENT_PROMO_ERROR,
    };
  }
  return response;
};

export const usePreviewEventStripeDiscount = () =>
  useMutation({
    mutationFn: async (body: PreviewEventStripeDiscountRequest) => {
      try {
        const { data } = await axiosInstance.post<PreviewEventStripeDiscountResponse>(
          getAPIURL("/Event/preview-stripe-event-discount"),
          body,
        );
        return sanitizePreviewResponse(data);
      } catch (e: unknown) {
        if (axios.isAxiosError(e)) {
          const ax = e as AxiosError<PreviewEventStripeDiscountResponse>;
          if (ax.response?.data && typeof ax.response.data === "object")
            return sanitizePreviewResponse(ax.response.data);
        }
        throw e;
      }
    },
  });
